export default __webpack_public_path__ + "642760398480269f1dca74b23af68db8.jpg";